import { modal } from 'vue-strap'
import { focusable, visible } from './controls'

const openDialogs = []
const backgroundIsolation = []

function isolate (el) {
    let record = backgroundIsolation.filter(item => item.el === el)[0]
    if (!record) {
        record = { el, hidden: el.getAttribute('aria-hidden'), count: 0 }
        backgroundIsolation.push(record)
    }
    record.count++
    el.setAttribute('aria-hidden', 'true')
    return record
}

function release (record) {
    record.count--
    if (record.count) return
    if (record.hidden === null) record.el.removeAttribute('aria-hidden')
    else record.el.setAttribute('aria-hidden', record.hidden)
    backgroundIsolation.splice(backgroundIsolation.indexOf(record), 1)
}

export default {
    extends: modal,
    props: {
        // Non-dismissible payment/session dialogs must opt out explicitly.
        escapeCloses: { type: Boolean, default: true }
    },
    mounted () {
        this._returnFocus = document.activeElement
        this.$el.addEventListener('keydown', this.onDialogKey)
        document.addEventListener('focusin', this.onDialogFocus, true)
        document.addEventListener('click', this.onBackgroundClick, true)
        this.$nextTick(this.syncDialog)
    },
    updated () { this.syncDialog() },
    watch: {
        val (value) {
            if (value) {
                this._returnFocus = document.activeElement
                this.$nextTick(this.syncDialog)
            } else this.releaseDialog()
        },
        transition () { this.$nextTick(this.syncDialog) }
    },
    beforeDestroy () {
        this.$el.removeEventListener('keydown', this.onDialogKey)
        document.removeEventListener('focusin', this.onDialogFocus, true)
        document.removeEventListener('click', this.onBackgroundClick, true)
        this.releaseDialog()
    },
    methods: {
        syncDialog () {
            if (!this.val || !visible(this.$el)) return
            this.$el.setAttribute('aria-modal', 'true')
            this.$el.setAttribute('tabindex', '-1')
            const heading = this.$el.querySelector('h1, h2, h3, h4, .modal-title')
            if (!this.$attrs['aria-label'] && !this.$attrs['aria-labelledby']) {
                if (heading && heading.textContent.trim()) {
                    if (!heading.id) heading.id = 'tone-dialog-title-' + this._uid
                    this.$el.setAttribute('aria-labelledby', heading.id)
                } else this.$el.setAttribute('aria-label', this.title || 'Dialog')
            }
            Array.prototype.forEach.call(this.$el.querySelectorAll('button.close'), close => close.setAttribute('aria-label', 'Close dialog'))
            if (!this._dialogActive) {
                this._dialogActive = true
                openDialogs.push(this)
                this.focusDialog()
                this._background = []
                let node = this.$el
                while (node.parentElement && node !== document.body) {
                    Array.prototype.forEach.call(node.parentElement.children, sibling => {
                        if (sibling === node || /^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName)) return
                        this._background.push(isolate(sibling))
                    })
                    node = node.parentElement
                }
            }
        },
        focusDialog () {
            const target = focusable(this.$el)[0] || this.$el
            target.focus()
        },
        onDialogFocus (event) {
            if (openDialogs[openDialogs.length - 1] === this && !this.$el.contains(event.target)) this.focusDialog()
        },
        onBackgroundClick (event) {
            if (openDialogs[openDialogs.length - 1] === this && !this.$el.contains(event.target)) {
                event.preventDefault()
                event.stopPropagation()
            }
        },
        onDialogKey (event) {
            if (openDialogs[openDialogs.length - 1] !== this) return
            if (event.key === 'Escape' && this.escapeCloses) {
                event.preventDefault()
                event.stopPropagation()
                this.action(false, 2)
            }
            if (event.key !== 'Tab') return
            const items = focusable(this.$el)
            const first = items[0] || this.$el
            const last = items[items.length - 1] || this.$el
            if (!items.length || (event.shiftKey && (document.activeElement === first || document.activeElement === this.$el))) {
                event.preventDefault()
                last.focus()
            } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === this.$el)) {
                event.preventDefault()
                first.focus()
            }
        },
        releaseDialog () {
            if (!this._dialogActive) return
            this._dialogActive = false
            const index = openDialogs.indexOf(this)
            if (index !== -1) openDialogs.splice(index, 1)
            ;(this._background || []).forEach(release)
            this._background = []
            const top = openDialogs[openDialogs.length - 1]
            if (top) top.focusDialog()
            else if (document.documentElement.contains(this._returnFocus) && visible(this._returnFocus)) this._returnFocus.focus()
            else {
                const main = document.getElementById('main-content')
                if (main) main.focus()
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/accessibility/Modal.js